import { createStyles, Divider, Drawer, Grid, makeStyles, Typography, PropTypes } from '@material-ui/core';
import { BaseDocumentResponse } from 'common/genericTypes';
import React from 'react';
import { SmSpace, Button, LgSpace } from 'm2m.components';
import { GetApp, InsertDriveFile } from '@material-ui/icons';

const useStyles = makeStyles(() =>
  createStyles({
    anexoListItem: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: 10,
      paddingBottom: 10,
    },
    anexoListItemText: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'flex-end',
      textAlign: 'right',
    },
  })
);

export interface GenericDrawerProps {
  opened: boolean;
  onClose(): void;
  title: string;
  textContents?: Array<GenericDrawerTextContent>;
  downloadDocuments?: Array<GenericDrawerDocumentBehaviour>;
  buttons?: Array<GenericDrawerButtonBehaviour>;
  disableButtons?: boolean;
}

export interface GenericDrawerTextContent {
  subtitle?: string;
  text?: string;
  space?: boolean;
  header?: string;
}

export interface GenericDrawerButtonBehaviour {
  buttonText: string;
  buttonAction(): void;
  buttonColor?: PropTypes.Color | 'error';
  buttonDisable?: boolean;
}

export interface GenericDrawerDocumentBehaviour extends BaseDocumentResponse {
  downloadDocument?(): void;
}

export const GenericDrawer: React.FC<GenericDrawerProps> = (props) => {
  const { opened, onClose, title, textContents, downloadDocuments, buttons, disableButtons } = props;
  const style = useStyles();

  return (
    <Drawer anchor="right" open={opened} onClose={onClose} PaperProps={{ style: { padding: '40px', width: 520 } }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h3">{title}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <SmSpace />
        </Grid>
        {!!textContents &&
          textContents.map((text, i) => (
            <React.Fragment key={i}>
              {text.header && (
                <Grid item xs={12}>
                  <Typography variant="h6">{text.header}</Typography>
                </Grid>
              )}
              {text.subtitle && (
                <Grid item xs={12}>
                  <Typography variant="body1">{text.subtitle}</Typography>
                </Grid>
              )}
              {text.text && (
                <Grid item xs={12}>
                  <Typography variant="body2">{text.text}</Typography>
                  <SmSpace />
                </Grid>
              )}
              {text.space && (
                <Grid item xs={12}>
                  <SmSpace />
                </Grid>
              )}
            </React.Fragment>
          ))}
        <LgSpace />
        {!!downloadDocuments && downloadDocuments.length > 0 && (
          <Grid item xs={12}>
            {downloadDocuments.map((doc, i) => (
              <Grid
                item
                xs={12}
                key={i}
                className={style.anexoListItem}
                style={{ borderTop: i > 0 ? '1px solid #C4C4C4' : '' }}
              >
                <Grid item md={8} className={style.anexoListItemText}>
                  <InsertDriveFile style={{ marginRight: 10 }} fontSize={'small'} />
                  <Typography variant="caption" style={{ marginLeft: 10 }}>{`${doc.fileName} - ${Math.round((doc.size / 1000000) * 100) / 100
                    }MB`}</Typography>
                </Grid>
                <Grid item md={4} className={style.anexoListItemText}>
                  <GetApp style={{ marginLeft: 20 }} />
                  <Button onClick={doc.downloadDocument} variant="text">
                    {'Download'}
                  </Button>
                </Grid>
              </Grid>
            ))}
            <SmSpace />
          </Grid>
        )}
        <Grid item xs={12}>
          {props.children}
          {!!buttons &&
            buttons.map((button, i) => (
              <div key={i}>
                <Button
                  onClick={button.buttonAction}
                  variant={button.buttonColor ? 'contained' : 'outlined'}
                  color={button.buttonColor}
                  fullWidth
                  disabled={(!!disableButtons ? true : (button.buttonDisable ? true : false))}
                >
                  {button.buttonText}
                </Button>
                <SmSpace />
              </div>
            ))}
        </Grid>
      </Grid>
    </Drawer>
  );
};
